(function(){"use strict";try{if(typeof document<"u"){var t=document.createElement("style");t.appendChild(document.createTextNode(".container{position:absolute;top:0;right:0;left:0;bottom:0;display:flex;justify-content:center;transition:all 70ms linear}.icon-container{position:absolute;padding:4px;border-radius:9999px;box-shadow:0 4px 6px #0000001a}.transition-all{transition-property:all;transition-timing-function:cubic-bezier(.4,0,.2,1);transition-duration:.15s}@keyframes spin{0%{transform:rotate(0)}to{transform:rotate(360deg)}}")),document.head.appendChild(t)}}catch(n){console.error("vite-plugin-css-injected-by-js",n)}})();
import { defineComponent as C, ref as s, onMounted as $, onUnmounted as L, computed as n, openBlock as p, createElementBlock as g, normalizeStyle as v, createElementVNode as f, renderSlot as T } from "vue";
const N = ["width", "height"], B = ["fill"], k = /* @__PURE__ */ C({
  __name: "Vue3PullToRefresh",
  props: {
    distance: {
      type: Number,
      default: 50
    },
    duration: {
      type: Number,
      default: 1e3
    },
    size: {
      type: Number,
      default: 32
    },
    coefficient: {
      type: Number,
      default: 2.5
    },
    noreload: {
      type: Boolean,
      default: !1
    },
    options: {
      type: Object,
      default: () => ({
        color: "#000",
        bgColor: "#fff"
      })
    }
  },
  emits: ["onrefresh"],
  setup(i, { emit: y }) {
    const x = y, e = i, a = s(0), o = s(0), r = window.innerHeight / e.distance / e.coefficient, l = s(!1), c = s(0);
    $(() => {
      window.addEventListener("touchstart", h), window.addEventListener("touchmove", m), window.addEventListener("touchend", w);
    }), L(() => {
      window.removeEventListener("touchstart", h), window.removeEventListener("touchmove", m), window.removeEventListener("touchend", w);
    });
    function h(t) {
      a.value = t.touches[0].clientY, o.value = t.touches[0].clientY;
    }
    function m(t) {
      o.value = t.touches[0].clientY;
    }
    function w() {
      u.value / r >= e.distance ? (l.value = !0, setTimeout(() => {
        l.value = !1, a.value = 0, o.value = 0, x("onrefresh"), e.noreload || location.reload();
      }, e.duration)) : (l.value = !1, a.value = 0, o.value = 0);
    }
    const u = n(() => o.value - a.value), d = n(() => u.value / r > e.distance ? e.distance : u.value / r), z = n(() => ({
      height: `${d.value}px`,
      width: "100%"
    })), _ = n(() => ({
      top: `${d.value * 1.5}px`,
      width: `${e.size}px`,
      height: `${e.size}px`,
      backgroundColor: e.options.bgColor,
      transform: "translateY(-100%)"
    })), E = n(() => {
      const t = 360 / e.distance;
      return c.value = b(d.value * t), {
        transform: `rotate(${c.value}deg)`,
        width: "100%",
        height: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
      };
    }), S = n(() => ({
      transform: `rotate(${c.value * -1}deg)`,
      animation: "spin 1s linear infinite",
      width: "100%",
      height: "100%",
      display: "flex",
      justifyContent: "center",
      alignItems: "center"
    }));
    function b(t) {
      return (t % 360 + 360) % 360;
    }
    return (t, Y) => (p(), g("div", {
      style: v(z.value),
      class: "container"
    }, [
      f("div", {
        class: "icon-container transition-all",
        style: v(_.value)
      }, [
        f("div", {
          style: v(l.value ? S.value : E.value)
        }, [
          T(t.$slots, "default", {}, () => [
            (p(), g("svg", {
              xmlns: "http://www.w3.org/2000/svg",
              width: i.size,
              height: i.size,
              viewBox: "0 0 24 24"
            }, [
              f("path", {
                fill: i.options.color,
                d: "M17.65 6.35a7.95 7.95 0 0 0-6.48-2.31c-3.67.37-6.69 3.35-7.1 7.02C3.52 15.91 7.27 20 12 20a7.98 7.98 0 0 0 7.21-4.56c.32-.67-.16-1.44-.9-1.44c-.37 0-.72.2-.88.53a5.994 5.994 0 0 1-6.8 3.31c-2.22-.49-4.01-2.3-4.48-4.52A6.002 6.002 0 0 1 12 6c1.66 0 3.14.69 4.22 1.78l-1.51 1.51c-.63.63-.19 1.71.7 1.71H19c.55 0 1-.45 1-1V6.41c0-.89-1.08-1.34-1.71-.71z"
              }, null, 8, B)
            ], 8, N))
          ])
        ], 4)
      ], 4)
    ], 4));
  }
});
export {
  k as default
};
